import React from "react"

const BirdSvg = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="13.79"
        viewBox="0 0 50 13.79"
      >
        <path
          fill="#fff"
          d="M27.93 11.46l-3.21-3.59s-5.84-4.1-7.81-3.58S3.85 8.8 1.47 10.6s4.79-4.55 6.39-5.41S17.4 1 18.26 1.71s8.82 3.93 8.82 3.93S34.6.49 36.75.49 49.6 13.12 49.6 13.12 37.59 3 36 3.84s-6.88 4.3-6.88 4.3L28 11.22"
        ></path>
      </svg>
    </div>
  )
}

export default BirdSvg
